import QuestionPicker from './QuestionPicker';

export default QuestionPicker;
